require('./RASuitabilityTestRetryModal.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const OKModal = require('commonsComponents/OKModal');
const { RadioButton } = require('commonsComponents/radioButton');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');

// @constants
const {
    PROC_RA_SUITABILITY_TEST_VIEW,
    PROC_RA_SUITABILITY_TEST_RETRY_MODAL,
    PROC_RA_SUITABILITY_TEST_INTERACTION,
} = require('../../raConstants');

// @utilities
const { FormattedText, formatText } = require('core/i18n').i18n;
const { recordLink } = require('utilities/tagging');

class RASuitabilityTestRetryModal extends React.Component {
    componentDidMount() {
        recordLink(
            PROC_RA_SUITABILITY_TEST_INTERACTION,
            PROC_RA_SUITABILITY_TEST_RETRY_MODAL,
            PROC_RA_SUITABILITY_TEST_VIEW,
        );
    }

    buildModalTitle() {
        return (
            <div className="ra-suitability-test-retry-modal__title">
                <FormattedText value="raSuitabilityTestRetryModal-raSuitabilityTestRetryModal_title" />
            </div>
        );
    }

    buildRadioButtons(selectedValue) {
        return (
            <div className="ra-suitability-test-retry-modal__radio-group">
                <RadioButtonGroup
                    idPrefix="retryAnswer"
                    key="retryAnswer"
                    name="retryReason"
                    onChange={this.props.onRetryReasonChange}
                    selectedValue={selectedValue}
                    value={selectedValue}
                >
                    <RadioButton
                        label={formatText(
                            'raSuitabilityTestRetryModal-raSuitabilityTestRetryModal_radioOption1',
                        )}
                        value="answer1"
                        className="ra-suitability-test-retry-modal__radio"
                    />
                    <RadioButton
                        label={formatText(
                            'raSuitabilityTestRetryModal-raSuitabilityTestRetryModal_radioOption2',
                        )}
                        value="answer2"
                        className="ra-suitability-test-retry-modal__radio"
                    />
                    <RadioButton
                        label={formatText(
                            'raSuitabilityTestRetryModal-raSuitabilityTestRetryModal_radioOption3',
                        )}
                        value="answer3"
                        className="ra-suitability-test-retry-modal__radio"
                    />
                    <RadioButton
                        label={formatText(
                            'raSuitabilityTestRetryModal-raSuitabilityTestRetryModal_radioOption4',
                        )}
                        value="answer4"
                        className="ra-suitability-test-retry-modal__radio"
                    />
                </RadioButtonGroup>
            </div>
        );
    }

    buildModalButtons(selectedValue) {
        const {
            handleCancelButtonAction,
            handlePrimaryButtonAction,
        } = this.props;
        return (
            <div className="ra-suitability-test-retry-modal__buttons">
                <div className="ra-suitability-test-retry-modal__button-left">
                    <OKButton
                        modifier="ghost"
                        onClick={handleCancelButtonAction}
                    >
                        <FormattedText
                            value="buttonsActions-cancel"
                            format="firstUppercase"
                        />
                    </OKButton>
                </div>
                <div className="ra-suitability-test-retry-modal__button-right">
                    <OKButton
                        onClick={handlePrimaryButtonAction}
                        disabled={!selectedValue}
                    >
                        <FormattedText value="common-continue" />
                    </OKButton>
                </div>
            </div>
        );
    }

    render() {
        const { selectedValue } = this.props;
        const modalTitle = this.buildModalTitle();
        const modalRadioButtons = this.buildRadioButtons(selectedValue);
        const modalButtons = this.buildModalButtons(selectedValue);
        const modalContent = (
            <div className="ra-suitability-test-retry-modal__wrapper">
                <div className="ra-suitability-test-retry-modal__content">
                    <div className="ra-suitability-test-retry-modal__icon" />
                    {modalTitle}
                    {modalRadioButtons}
                </div>
                {modalButtons}
            </div>
        );

        return (
            <OKModal
                isOpen={true}
                extraClass="ra-suitability-test-retry-modal"
                shouldCloseOnOverlayClick={false}
                onCloseCallback={this.props.closeModal} // eslint-disable-line
                content={modalContent}
            />
        );
    }
}

RASuitabilityTestRetryModal.propTypes = {
    closeModal: PropTypes.func,
    handleCancelButtonAction: PropTypes.func,
    handlePrimaryButtonAction: PropTypes.func,
    identifier: PropTypes.number,
    onRetryReasonChange: PropTypes.func.isRequired,
    selectedValue: PropTypes.string,
    onMount: PropTypes.func,
};

module.exports = RASuitabilityTestRetryModal;
